import { Menu } from 'react-feather'
import {
  NavItem,
  NavLink
} from 'reactstrap'

import themeConfig from '@configs/themeConfig'
import {useSkin} from "../../../../utility/hooks/useSkin"

const NavbarBookmarks = props => {
  // ** Props
  const { setMenuVisibility } = props
  const { skin } = useSkin()


  return (
    <>
      <ul className='navbar-nav d-xl-none align-items-center'>
        <a href={'/'}><img width={50} height={11} className='fallback-logo' src={skin === 'light' ? themeConfig.app.appLogoCollapsed : themeConfig.app.appLogoCollapsedDarkMode} alt='logo' /></a>
        <NavItem className='mobile-menu me-auto' style={{marginTop: '8px'}}>
          <NavLink className='nav-menu-main menu-toggle hidden-xs is-active' onClick={() => setMenuVisibility(true)}>
            <Menu className='ficon' />
          </NavLink>
        </NavItem>
      </ul>
    </>
  )
}

export default NavbarBookmarks
